var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-content-wrap"},[(_vm.isPdf)?_c('div',{staticClass:"pdf-content"},_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,staticClass:"pdf-content",attrs:{"page":i,"src":_vm.curFileSrc}})}),1):_c('img',{staticClass:"file-content",attrs:{"src":_vm.curFileSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }